module.exports = __webpack_public_path__ + "img/h3.53a848e7.jpg";